import { render, staticRenderFns } from "./CreateIssue.vue?vue&type=template&id=5bec7d88&"
import script from "./CreateIssue.vue?vue&type=script&lang=js&"
export * from "./CreateIssue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports